<template>
  <div class="player-log-container">
    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-form :inline="true" :model="formInline" class="filter-form">
        <!-- 非嵌入模式显示联赛ID和比赛ID筛选 -->
        <template v-if="!embedded">
          <el-form-item label="联赛ID">
            <el-select v-model="formInline.contestId" placeholder="请选择联赛ID" clearable>
              <el-option v-for="option in tableData1" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="比赛ID">
            <el-input v-model="formInline.tournamentId" placeholder="请输入比赛ID" clearable @blur="getTeamList"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="球队">
          <el-select v-model="formInline.basketballTeamId" placeholder="请先输入比赛ID" clearable @change="getPlayerList">
            <el-option v-for="option in teamOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="球员">
          <el-select
            v-model="formInline.basketballPlayerId"
            placeholder="请输入球员名称搜索"
            clearable
            filterable
            remote
            :remote-method="searchPlayerList"
            :loading="playerLoading"
          >
            <el-option v-for="option in playerOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="inquire">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          <el-button type="success" icon="el-icon-plus" @click="openAddDialog">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
		<div>
			<el-table
			  :data="tableData"
			  border
			  stripe
			  highlight-current-row
			  v-loading="listLoading"
			  ref="table"
			  style="width: 100%;"
			  :header-cell-style="{background: '#f5f7fa', color: '#606266', fontWeight: 'bold'}"
			>
			  <el-table-column prop="id" label="ID" min-width="100" align="center" show-overflow-tooltip></el-table-column>
			  <el-table-column prop="tournamentId" label="比赛ID" min-width="100" align="center"></el-table-column>
			  <el-table-column prop="playerName" label="球员名称" min-width="100" align="center" show-overflow-tooltip></el-table-column>
			  <el-table-column prop="playerNumber" label="球员编号" min-width="100" align="center"></el-table-column>
			  <el-table-column prop="type" label="操作类型" min-width="100" align="center">
			    <template slot-scope="scope">
			      <el-tag :type="getTypeTagColor(scope.row.type)" size="medium">
			        {{ getTypeLabel(scope.row.type) }}
			      </el-tag>
			    </template>
			  </el-table-column>
			  <el-table-column prop="subsection" label="节数" min-width="100" align="center">
			    <template slot-scope="scope">
			      <el-tag type="info" size="small">第{{ scope.row.subsection }}节</el-tag>
			    </template>
			  </el-table-column>
			  <el-table-column label="操作" min-width="200" align="center" fixed="right">
			    <template slot-scope="scope">
			      <el-button
			        type="primary"
			        size="mini"
			        icon="el-icon-edit"
			        @click="edit(scope.row)"
			      >编辑</el-button>
			      <el-button
			        type="danger"
			        size="mini"
			        icon="el-icon-delete"
			        @click="del(scope.row)"
			      >删除</el-button>
			    </template>
			  </el-table-column>
			</el-table>
		</div>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-section">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="newPlayerLog.id ? '编辑球员数据' : '新增球员数据'"
      :visible.sync="addDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form :model="newPlayerLog" ref="addForm" label-width="100px" class="dialog-form">
        <!-- 新增时显示联动字段 -->
        <template v-if="!newPlayerLog.id">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="比赛ID" prop="tournamentId" required>
                <el-input v-model="newPlayerLog.tournamentId" placeholder="请输入比赛ID" @blur="getNewTeamList" :disabled="embedded"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="球队" prop="basketballTeamId" required>
                <el-select v-model="newPlayerLog.basketballTeamId" placeholder="请先输入比赛ID" clearable @change="getNewPlayerList" style="width: 100%;">
                  <el-option v-for="option in newTeamOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="球员名称" prop="playerName" required>
                <el-select
                  v-model="newPlayerLog.basketballPlayerId"
                  placeholder="请输入球员名称搜索"
                  clearable
                  style="width: 100%;"
                  @change="handlePlayerChange"
                  filterable
                  remote
                  :remote-method="searchNewPlayerList"
                  :loading="newPlayerLoading"
                >
                  <el-option v-for="option in newPlayerOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-for="(log, index) in newPlayerLog.logList" :gutter="20">
            <el-col :span="10">
              <el-form-item label="节数" prop="subsection">
                <el-input-number v-model="log.subsection" :min="1" :max="7" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-col>
			<el-col :span="10">
			  <el-form-item label="操作类型">
			    <el-select v-model="log.type" placeholder="请选择操作类型" clearable style="width: 100%;">
			      <el-option v-for="option in typeOptions" :key="option.code" :label="option.info" :value="option.code"></el-option>
			    </el-select>
			  </el-form-item>
			</el-col>
			<el-col :span="4"><el-button size="mini" type="danger" @click="delLogItem(index)" icon="el-icon-delete-solid"></el-button></el-col>
          </el-row>
		  <el-form-item label="" prop="" >
			  <el-button size="mini" type="success" @click="addLogItem" icon="el-icon-plus"></el-button>
		  </el-form-item>
        </template>

        <!-- 编辑时只显示操作类型和节数 -->
        <template v-else>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="操作类型" prop="type" required>
                <el-select v-model="newPlayerLog.type" placeholder="请选择操作类型" clearable style="width: 100%;">
                  <el-option v-for="option in typeOptions" :key="option.code" :label="option.info" :value="option.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="节数" prop="subsection">
                <el-input-number v-model="newPlayerLog.subsection" :min="1" :max="4" style="width: 100%;"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="addNewPlayerLog" :loading="isAddLogLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { playerLogList, playerLogDelete, contestListDown, playerLogSave, playerLogModify, playerLogDownBox, getTeamByTournamentId, playerList } from '@/api/table'

export default {
  name: 'PlayerLog',
  props: {
    // 是否为嵌入模式（在比赛管理中使用）
    embedded: {
      type: Boolean,
      default: false
    },
    // 嵌入模式下传入的比赛ID
    tournamentId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      tableData1: [],
      tableData: [],
      typeOptions: [],
      teamOptions: [],
      playerOptions: [],
      newTeamOptions: [],
      newPlayerOptions: [],
      listLoading: false,
      playerLoading: false,
      newPlayerLoading: false,
      formInline: {
        contestId: '',
        tournamentId: '',
        basketballTeamId: '',
        basketballPlayerId: ''
      },
      newPlayerLog: {
        id: '',
        tournamentId: '',
        basketballTeamId: '',
        basketballPlayerId: '',
        playerName: '',
        playerNumber: '',
        type: '',
        subsection: 1,
        remark: '',
		logList: [{
			type: '',
			subsection: 1
		}]
      },
	  isAddLogLoading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      addDialogVisible: false
    }
  },
  watch: {
    // 监听传入的tournamentId变化
    tournamentId: {
      handler(newVal) {
        if (this.embedded && newVal) {
          this.formInline.tournamentId = newVal
          this.newPlayerLog.tournamentId = newVal
          this.getTeamList()
          this.reqData()
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 非嵌入模式才加载联赛列表
    if (!this.embedded) {
      this.reqContestList()
    }
    this.reqTypeOptions()
    // 非嵌入模式才自动请求数据
    if (!this.embedded) {
      this.reqData()
    }
  },
  methods: {
	delLogItem (index) {
		this.newPlayerLog.logList.splice(index,1)
	},
	addLogItem () {
		this.newPlayerLog.logList.push({
			type: '',
			subsection: this.newPlayerLog.logList[this.newPlayerLog.logList.length - 1]? this.newPlayerLog.logList[this.newPlayerLog.logList.length - 1].subsection : 1
		})
	},
    openAddDialog() {
      this.addDialogVisible = true
      this.resetFormData()
      // 嵌入模式下自动设置比赛ID并获取球队列表
      if (this.embedded && this.tournamentId) {
        this.newPlayerLog.tournamentId = this.tournamentId
        this.$nextTick(() => {
          this.getNewTeamList()
        })
      }
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    // 获取球队列表
    getTeamList() {
      if (!this.formInline.tournamentId) {
        this.teamOptions = []
        this.formInline.basketballTeamId = ''
        this.playerOptions = []
        this.formInline.basketballPlayerId = ''
        return
      }
      getTeamByTournamentId({ tournamentId: this.formInline.tournamentId }).then(res => {
        if (res.code === 200) {
          this.teamOptions = res.data.map(item => ({
            value: item.id,
            label: item.teamName || item.name
          }))
        }
      }).catch(() => {
        this.teamOptions = []
      })
    },
    // 获取球员列表
    getPlayerList() {
      if (!this.formInline.basketballTeamId) {
        this.playerOptions = []
        this.formInline.basketballPlayerId = ''
        return
      }
      // 初始加载时只加载前20条
      this.searchPlayerList('', this.formInline.basketballTeamId)
    },
    // 搜索球员列表（筛选区域）
    searchPlayerList(query, teamId) {
      const targetTeamId = teamId || this.formInline.basketballTeamId
      if (!targetTeamId) {
        this.playerOptions = []
        return
      }
      this.playerLoading = true
      playerList({
        teamId: targetTeamId,
        playerName: query || '',
        pageNum: 1,
        pageSize: 20
      }).then(res => {
        if (res.code === 200) {
          this.playerOptions = (res.data || res.rows || []).map(item => ({
            value: item.id,
            label: `${item.playerName || item.name}(${item.playerNumber || item.number})`
          }))
        }
      }).catch(() => {
        this.playerOptions = []
      }).finally(() => {
        this.playerLoading = false
      })
    },
    // 新增对话框 - 获取球队列表
    getNewTeamList() {
      if (!this.newPlayerLog.tournamentId) {
        this.newTeamOptions = []
        this.newPlayerLog.basketballTeamId = ''
        this.newPlayerOptions = []
        this.newPlayerLog.playerName = ''
        return
      }
      getTeamByTournamentId({ tournamentId: this.newPlayerLog.tournamentId }).then(res => {
        if (res.code === 200) {
          this.newTeamOptions = res.data.map(item => ({
            value: item.id,
            label: item.teamName || item.name
          }))
        }
      }).catch(() => {
        this.newTeamOptions = []
      })
    },
    // 新增对话框 - 获取球员列表
    getNewPlayerList() {
      if (!this.newPlayerLog.basketballTeamId) {
        this.newPlayerOptions = []
        this.newPlayerLog.basketballPlayerId = ''
        this.newPlayerLog.playerName = ''
        return
      }
      // 初始加载时只加载前20条
      this.searchNewPlayerList('', this.newPlayerLog.basketballTeamId)
    },
    // 搜索球员列表（新增对话框）
    searchNewPlayerList(query, teamId) {
      const targetTeamId = teamId || this.newPlayerLog.basketballTeamId
      if (!targetTeamId) {
        this.newPlayerOptions = []
        return
      }
      this.newPlayerLoading = true
      playerList({
        teamId: targetTeamId,
        playerName: query || '',
        pageNum: 1,
        pageSize: 20
      }).then(res => {
        if (res.code === 200) {
          this.newPlayerOptions = (res.data || res.rows || []).map(item => ({
            value: item.id,
            label: `${item.playerName || item.name}(${item.playerNumber || item.number})`
          }))
        }
      }).catch(() => {
        this.newPlayerOptions = []
      }).finally(() => {
        this.newPlayerLoading = false
      })
    },
    // 处理球员选择变化
    handlePlayerChange(value) {
      const selectedPlayer = this.newPlayerOptions.find(item => item.value === value)
      if (selectedPlayer) {
        this.newPlayerLog.playerName = selectedPlayer.label
      } else {
        this.newPlayerLog.playerName = ''
      }
    },

    edit(row) {
      this.resetFormData()
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.newPlayerLog = { ...row }
        // 保存 basketballTeamId
        if (row.basketballTeamId) {
          this.newPlayerLog.basketballTeamId = row.basketballTeamId
        }
      })
    },
    closeDialog() {
      this.addDialogVisible = false
      this.resetFormData()
    },
    resetFormData() {
      this.newPlayerLog = {
        id: '',
        tournamentId: this.embedded ? this.tournamentId : '',
        basketballTeamId: '',
        basketballPlayerId: '',
        playerName: '',
        playerNumber: '',
        type: '',
        subsection: 1,
        remark: '',
		logList: [{
			type: '',
			subsection: 1
		}]
      }
      this.newTeamOptions = []
      this.newPlayerOptions = []
    },

    reqTypeOptions() {
      playerLogDownBox({}).then(res => {
        if (res.code === 200) {
          this.typeOptions = res.data || []
        }
      }).catch(() => {})
    },
    getTypeLabel(value) {
      if (!value) return '-'
      const option = this.typeOptions.find(item => item.code === value)
      return option ? option.info : value
    },
    getTypeTagColor(value) {
      if (!value) return ''
      const colorMap = {
        1: 'success',
        2: 'warning',
        3: 'danger',
        4: 'info',
        5: ''
      }
      return colorMap[value] || ''
    },

    inquire() {
      this.pageNum = 1
      this.reqData(1, this.pageSize, {
        contestId: this.formInline.contestId,
        tournamentId: this.formInline.tournamentId,
        basketballTeamId: this.formInline.basketballTeamId,
        basketballPlayerId: this.formInline.basketballPlayerId
      })
    },
    // 重置查询条件
    resetSearch() {
      this.formInline = {
        contestId: '',
        tournamentId: this.embedded ? this.tournamentId : '',
        basketballTeamId: '',
        basketballPlayerId: ''
      }
      this.teamOptions = []
      this.playerOptions = []
      this.pageNum = 1
      this.reqData(1, this.pageSize)
    },
    selectionChange(selection) {
      this.selectionLength = selection.length
    },
    async addNewPlayerLog() {
      
      try {
        if (this.newPlayerLog.id) {
          // 编辑时传递 basketballTeamId 和 tournamentId
		  if (!this.newPlayerLog.type) {
		    this.$message.warning('请填写必填项')
		    return
		  }
		  
          const params = {
            id: this.newPlayerLog.id,
            type: this.newPlayerLog.type,
            subsection: this.newPlayerLog.subsection,
            basketballTeamId: this.newPlayerLog.basketballTeamId || '',
            tournamentId: this.newPlayerLog.tournamentId || ''
          }
          await playerLogModify(params)
          this.$message.success('修改成功')
        } else {
			
			let logList = this.newPlayerLog.logList
			
			
			for(let i = 0; i < logList.length; i++) {
				
				if (!logList[i].type) {
					this.$message.warning(`第${i + 1}条数据请选择操作类型`)
					return
				}
			}
			
			
          // 新增时的验证
          if (!this.newPlayerLog.tournamentId || !this.newPlayerLog.playerName) {
            this.$message.warning('请填写必填项')
            return
          }
          delete this.newPlayerLog.id
		  
		  this.isAddLogLoading = true
		  for(let i = 0; i < logList.length; i++) {
			  let newPlayerLog = JSON.parse(JSON.stringify(this.newPlayerLog))
			  delete newPlayerLog.logList
			  newPlayerLog.type = logList[i].type
			  newPlayerLog.subsection = logList[i].subsection
			  await playerLogSave(newPlayerLog)
		  }
		  this.isAddLogLoading = false
          this.$message.success('新增成功')
        }
        this.addDialogVisible = false
        // 保留查询条件，只刷新当前页数据
        this.reqData(this.pageNum, this.pageSize, {
          contestId: this.formInline.contestId,
          tournamentId: this.formInline.tournamentId,
          basketballTeamId: this.formInline.basketballTeamId,
          basketballPlayerId: this.formInline.basketballPlayerId
        })
      } catch (error) {
        this.$message.error('操作失败')
      }
    },
    reqData(pageNum = 1, pageSize = 10, query = {}) {
      this.listLoading = true
      const params = { pageNum, pageSize, ...query }
      // 如果是嵌入模式且没有传tournamentId，使用props中的值
      if (this.embedded && this.tournamentId && !params.tournamentId) {
        params.tournamentId = this.tournamentId
      }
      playerLogList(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.rows || []
          this.total = res.total || 0
          this.pageNum = pageNum
          this.pageSize = pageSize
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    reqContestList(pageNum = 1, pageSize = 10000, query = {}) {
      const params = { pageNum, pageSize, ...query }
      contestListDown(params).then(res => {
        if (res.code === 200) {
          this.tableData1 = res.data.map(item => ({
            value: item.id,
            label: item.name
          }))
        }
      }).catch(() => {})
    },
    async del(row) {
      this.$confirm('确定要删除该条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await playerLogDelete({ id: row.id })
          this.$message.success('删除成功')
          this.reqData(this.pageNum, this.pageSize, {
            contestId: this.formInline.contestId,
            tournamentId: this.formInline.tournamentId,
            basketballTeamId: this.formInline.basketballTeamId,
            basketballPlayerId: this.formInline.basketballPlayerId
          })
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.reqData(1, val, {
            contestId: this.formInline.contestId,
            tournamentId: this.formInline.tournamentId,
            basketballTeamId: this.formInline.basketballTeamId,
            basketballPlayerId: this.formInline.basketballPlayerId
          })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.reqData(val, this.pageSize, {
            contestId: this.formInline.contestId,
            tournamentId: this.formInline.tournamentId,
            basketballTeamId: this.formInline.basketballTeamId,
            basketballPlayerId: this.formInline.basketballPlayerId
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.player-log-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  background: #f0f2f5;
  overflow: scroll;

  .filter-section {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-section {
    flex: 1;
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: scroll;
    display: flex;
    flex-direction: column;

    ::v-deep .el-table {
      flex: 1;
      font-size: 14px;

      th {
        font-weight: 600;
      }

      .el-button--mini {
        padding: 7px 12px;
        margin: 0 4px;
      }
    }
  }

  .pagination-section {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    padding: 16px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    ::v-deep .el-pagination {
      .el-pagination__total {
        font-weight: 500;
      }
    }
  }

  .dialog-form {
    margin-top: 20px;
  }
}

// 下拉框加载提示样式
::v-deep .load-more-tip {
  text-align: center;
  padding: 8px 0;
  color: #909399;
  font-size: 12px;
  border-top: 1px solid #ebeef5;
}

::v-deep .no-data-tip {
  text-align: center;
  padding: 8px 0;
  color: #c0c4cc;
  font-size: 12px;
}
</style>
